import { render, staticRenderFns } from "./TabsDetailsFicheEntreprise.vue?vue&type=template&id=58bfa3ff&"
import script from "./TabsDetailsFicheEntreprise.vue?vue&type=script&lang=js&"
export * from "./TabsDetailsFicheEntreprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports